module.exports = {
  apiHost: "https://api.forestreach.sensoreal.app",
  assetsHost: "https://assets.forestreach.sensoreal.app",
  formTemplate: "default",

  header: {
    logo: "",
    text: {
      en: "Your Forest Reach Selections",
      ar: "",
    },
    color: "#fff",
  },
  footerLogo:
    "https://static-mbh.sgp1.cdn.digitaloceanspaces.com/avid-edm/general/AVID_White_72dpi.png",
  contact: {
    address: "99 Bong Bong rd, Huntley NSW 2530<br><br>Open 10am - 5pm, 7 days",
    email: "forestreach@avid.com.au",
    phone: "1800 373 224",
    website: "https://forestreach.avid.com.au",
  },

  links: {
    instagram: "https://www.instagram.com/avid_together/",
    facebook:
      "https://web.facebook.com/AVIDPropertyGroupAustralia/?_rdc=1&_rdr",
    linkedin: "https://au.linkedin.com/company/avid-property-group",
    privacy: "https://avid.com.au/privacy-policy",
    twitter: "",
    youtube: "https://www.youtube.com/channel/UCEnh4QABTOnsovDd-Hg45OQ",
  },
  style: {
    primaryColor: "#003a40",
    textColor: "#fff",
  },
};
